import React from "react";
import "./WhyUs.css";
import { useTranslation } from "react-i18next";
import { FaUsers, FaShieldAlt, FaHandsHelping, FaAward, FaClock, FaHeadset } from "react-icons/fa";

const items = [
  { key: "expertise", Icon: FaShieldAlt },
  { key: "trusted", Icon: FaUsers },
  { key: "tailored", Icon: FaHandsHelping },
  { key: "excellence", Icon: FaAward },
  { key: "responsiveness", Icon: FaClock },
  { key: "support", Icon: FaHeadset },
];

const WhyUs = () => {
  const { t } = useTranslation();
  return (
    <div className="whyus-wrapper full-bleed">
      <div className="whyus-inner container">
        <div className="whyus-header">
          <h2>{t("home.whyTitle")}</h2>
          <p className="lead">{t("home.whyLead")}</p>
        </div>

        <div className="whyus-grid">
          {items.map(({ key, Icon }, i) => (
            <article
              className="whyus-item hidden"
              key={key}
              tabIndex={0}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="whyus-visual">
                <div className="icon-bg">
                  <Icon aria-hidden="true" />
                </div>
              </div>
              <div className="whyus-body">
                <h3>{t(`home.whyItems.${key}.title`)}</h3>
                <p>{t(`home.whyItems.${key}.text`)}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
